import Button from "../design/Button";
import GModal from "../design/components/GModal";
import classes from "./RemoveVirtualNumberModal.module.css";

const RemoveVirtualNumberModal = ({
  visible,
  onClose,
  name,
  includedInPlan = false,
  onRemove,
  isLoading
}) => {
  return (
    <GModal
      visible={visible}
      closeModal={onClose}
      heading="Remove number"
      modalStyle={{ width: "440px" }}
      bodyWrapperStyle={{ paddingRight: "0" }}
      bottomButtons={[
        <Button
          variant="outlined"
          buttonText="Cancel"
          disabled={false}
          isLoading={false}
          hierarchy="white"
          onClick={onClose}
        />,
        <Button
          variant="filled"
          buttonText="Yes, Remove number"
          isLoading={isLoading}
          hierarchy="red"
          onClick={onRemove}
        />,
      ]}
      body={
        <div className={classes.removeModalContainer}>
          <p>
            Are you sure you want to remove <span>{name}</span> from your
            account?
          </p>
          {includedInPlan ? (
            <>
              <p>This number is included free with your license.</p>
              <p> Removing it means:</p>
              <ul>
                <li>
                  It stays active until the end of this billing cycle, then will
                  be removed.
                </li>
                <li>The free benefit won't transfer to another number.</li>
                <li>No new free number can be claimed for this license.</li>
                <li>This number may not be available again.</li>
              </ul>
            </>
          ) : (
            <>
              <p> Removing it means:</p>
              <ul>
                <li>
                  It stays active until the end of this billing cycle, then will
                  be removed.
                </li>
                <li>Billing will stop after removal.</li>
                <li>This number may not be available again.</li>
              </ul>
            </>
          )}
        </div>
      }
    />
  );
};

export default RemoveVirtualNumberModal;
